import React, { useState, useEffect } from "react";
import {
  FaHandshake,
  FaMicrochip,
  FaRegFileCode,
  FaTasks,
} from "react-icons/fa";

const WhyWorkWithUs = () => {
  const [activeCards, setActiveCards] = useState({});
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const touchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setIsTouchDevice(touchDevice);
  }, []);

  const handleCardClick = (index) => {
    if (isTouchDevice) {
      setActiveCards(prev => ({
        ...prev,
        [index]: !prev[index]
      }));
    }
  };

  const cardsData = [
    {
      id: 1,
      icon: FaHandshake,
      title: "Partnership Model",
      description: "We invest in building expertise in the products that we work with, enabling us to leverage fully its features and be consistent with its vision and style as we build on top of it. Our collaborative approach ensures that your success is our success.",
      color: "#ffd700"
    },
    {
      id: 2,
      icon: FaRegFileCode,
      title: "Range of Technology Skills",
      description: "From frontend to backend, mobile to cloud, our diverse technical expertise allows us to tackle any challenge. We stay ahead of technology trends to deliver cutting-edge solutions that drive business growth.",
      color: "#ffd700"
    },
    {
      id: 3,
      icon: FaMicrochip,
      title: "Cutting-Edge Innovation",
      description: "We leverage the latest technologies including AI, IoT, and blockchain to create future-ready solutions. Our R&D team constantly explores emerging tech to give you a competitive advantage.",
      color: "#ffd700"
    },
    {
      id: 4,
      icon: FaTasks,
      title: "Agile Processes",
      description: "Our agile methodology ensures rapid delivery, continuous feedback, and transparent communication. We adapt quickly to changing requirements while maintaining high quality standards.",
      color: "#ffd700"
    }
  ];

  return (
    <>
      <style>
        {`
          .why-work-section {
            background: linear-gradient(135deg, #1a5fa8 0%, #0d4a8a 50%, #0a3a6e 100%);
            padding: 25px 20px;
            overflow-x: hidden;
            width: 100%;
            position: relative;
          }

          .why-work-section::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at 20% 50%, rgba(255,106,42,0.08) 0%, transparent 50%);
            pointer-events: none;
          }

          .why-work-section .container {
            max-width: 1400px;
            margin: 0 auto;
            position: relative;
            z-index: 1;
          }

          .why-work-section .heading-wrapper {
            text-align: center;
            margin-bottom: 60px;
            animation: slideDown 0.8s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-60px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .why-work-section .subtitle {
            color: #ffd700;
            font-size: 18px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 4px;
            margin-bottom: 15px;
            opacity: 0.9;
          }

          .why-work-section .title {
            color: white;
            font-size: 56px;
            font-weight: 800;
            margin: 0;
            letter-spacing: 2px;
            background: linear-gradient(135deg, #ffffff 0%, #e0e0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .why-work-section .cards {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
          }

          .why-work-section .flip-card {
            background-color: transparent;
            height: 420px;
            perspective: 1500px;
            cursor: pointer;
          }

          .why-work-section .flip-card-inner {
            position: relative;
            width: 100%;
            height: 100%;
            text-align: center;
            transition: transform 0.7s cubic-bezier(0.4, 0.2, 0.2, 1);
            transform-style: preserve-3d;
            border-radius: 24px;
          }

          .why-work-section .flip-card:hover .flip-card-inner {
            transform: rotateY(180deg);
          }

          .why-work-section .flip-card.active .flip-card-inner {
            transform: rotateY(180deg);
          }

          .why-work-section .flip-front,
          .why-work-section .flip-back {
            position: absolute;
            width: 100%;
            height: 100%;
            backface-visibility: hidden;
            border-radius: 24px;
            padding: 30px 20px;
            box-sizing: border-box;
          }

          .why-work-section .flip-front {
            background: linear-gradient(135deg, #1a5fa8 0%, #0d4a8a 50%, #0a3a6e 100%);
            color: white;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border: 1px solid rgba(255, 106, 42, 0.2);
          }

          .why-work-section .flip-back {
            background: linear-gradient(145deg, #ffffff 0%, #f8f9ff 100%);
            color: #1a1a6e;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
            transform: rotateY(180deg);
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            overflow-y: auto;
          }

          .why-work-section .icon {
            font-size: 60px;
            color: #ffd700;
            margin-bottom: 30px;
            transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          }

          .why-work-section .flip-card:hover .icon {
            transform: scale(1.15) rotate(5deg);
            filter: drop-shadow(0 0 8px rgba(255, 106, 42, 0.5));
          }

          .why-work-section .flip-front h3 {
            font-size: 28px;
            line-height: 1.3;
            font-weight: 700;
            color: #fff;
            margin: 0;
            transition: color 0.3s ease;
          }

          .why-work-section .flip-card:hover .flip-front h3 {
            color: #ffd700;
          }

          .why-work-section .flip-back p {
            margin: 0;
            padding: 0;
            font-size: 18px;
            line-height: 1.7;
            font-weight: 500;
          }

          .why-work-section .flip-front .card-number {
            position: absolute;
            bottom: 20px;
            right: 20px;
            font-size: 12px;
            opacity: 0.4;
            font-weight: 600;
          }

          .why-work-section .flip-front::after {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: linear-gradient(45deg, #ffd700, #ff8c00);
            border-radius: 26px;
            opacity: 0;
            transition: opacity 0.4s ease;
            pointer-events: none;
            z-index: -1;
          }

          .why-work-section .flip-card:hover .flip-front::after {
            opacity: 0.5;
          }

          @keyframes fadeUp {
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          .why-work-section .fade-up {
            opacity: 0;
            transform: translateY(50px);
            animation: fadeUp 0.8s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards;
          }

          .why-work-section .delay-1 { animation-delay: 0.1s; }
          .why-work-section .delay-2 { animation-delay: 0.25s; }
          .why-work-section .delay-3 { animation-delay: 0.4s; }
          .why-work-section .delay-4 { animation-delay: 0.55s; }

          @media (min-width: 1400px) {
            .why-work-section .flip-card {
              height: 350px;
            }
            .why-work-section .flip-front h3 {
              font-size: 32px;
            }
            .why-work-section .icon {
              font-size: 70px;
            }
          }

          @media (max-width: 1200px) {
            .why-work-section .title {
              font-size: 48px;
            }
            .why-work-section .cards {
              gap: 25px;
            }
            .why-work-section .flip-front h3 {
              font-size: 24px;
            }
            .why-work-section .flip-back p {
              font-size: 16px;
            }
          }

          @media (max-width: 992px) {
            .why-work-section {
              padding: 50px 20px;
            }
            .why-work-section .cards {
              grid-template-columns: repeat(2, 1fr);
              gap: 25px;
            }
            .why-work-section .title {
              font-size: 42px;
            }
            .why-work-section .subtitle {
              font-size: 16px;
              letter-spacing: 3px;
            }
            .why-work-section .flip-card {
              height: 400px;
            }
            .why-work-section .flip-front h3 {
              font-size: 22px;
            }
            .why-work-section .icon {
              font-size: 52px;
            }
          }

          @media (max-width: 768px) {
            .why-work-section {
              padding: 40px 15px;
            }
            .why-work-section .title {
              font-size: 36px;
            }
            .why-work-section .subtitle {
              font-size: 14px;
              letter-spacing: 2px;
            }
            .why-work-section .heading-wrapper {
              margin-bottom: 40px;
            }
            .why-work-section .cards {
              gap: 20px;
            }
            .why-work-section .flip-card {
              height: 380px;
            }
            .why-work-section .flip-front h3 {
              font-size: 20px;
            }
            .why-work-section .icon {
              font-size: 48px;
              margin-bottom: 20px;
            }
            .why-work-section .flip-back p {
              font-size: 15px;
              line-height: 1.6;
            }
            .why-work-section .flip-front,
            .why-work-section .flip-back {
              padding: 25px 18px;
            }
          }

          @media (max-width: 576px) {
            .why-work-section {
              padding: 30px 12px;
            }
            .why-work-section .cards {
              grid-template-columns: 1fr;
              gap: 20px;
            }
            .why-work-section .title {
              font-size: 32px;
            }
            .why-work-section .subtitle {
              font-size: 12px;
              letter-spacing: 2px;
              margin-bottom: 10px;
            }
            .why-work-section .flip-card {
              height: auto;
              min-height: 340px;
            }
            .why-work-section .flip-front h3 {
              font-size: 22px;
            }
            .why-work-section .icon {
              font-size: 48px;
              margin-bottom: 18px;
            }
            .why-work-section .flip-back p {
              font-size: 15px;
              line-height: 1.6;
              padding: 0 5px;
            }
            .why-work-section .flip-front,
            .why-work-section .flip-back {
              padding: 30px 20px;
            }
          }

          @media (max-width: 480px) {
            .why-work-section .title {
              font-size: 28px;
            }
            .why-work-section .flip-card {
              min-height: 320px;
            }
            .why-work-section .flip-front h3 {
              font-size: 20px;
            }
            .why-work-section .icon {
              font-size: 42px;
              margin-bottom: 15px;
            }
            .why-work-section .flip-back p {
              font-size: 14px;
              line-height: 1.5;
            }
          }

          @media (max-width: 375px) {
            .why-work-section .title {
              font-size: 24px;
            }
            .why-work-section .flip-card {
              min-height: 300px;
            }
            .why-work-section .flip-front h3 {
              font-size: 18px;
            }
            .why-work-section .icon {
              font-size: 36px;
              margin-bottom: 12px;
            }
            .why-work-section .flip-back p {
              font-size: 13px;
            }
            .why-work-section .flip-front,
            .why-work-section .flip-back {
              padding: 20px 15px;
            }
          }

          @media (hover: none) and (pointer: coarse) {
            .why-work-section .flip-card .flip-card-inner {
              transform: none;
              transition: transform 0.3s ease;
            }
            
            .why-work-section .flip-card.active .flip-card-inner {
              transform: rotateY(180deg);
            }
            
            .why-work-section .flip-card:hover .flip-card-inner {
              transform: none;
            }
            
            .why-work-section .flip-card.active .flip-front::after {
              opacity: 0.3;
            }
          }

          @media (prefers-reduced-motion: reduce) {
            .why-work-section *,
            .why-work-section .flip-card-inner,
            .why-work-section .icon,
            .why-work-section .fade-up {
              transition-duration: 0.01ms !important;
              animation-duration: 0.01ms !important;
            }
          }

          .why-work-section .flip-back::-webkit-scrollbar {
            width: 4px;
          }
          
          .why-work-section .flip-back::-webkit-scrollbar-track {
            background: #e0e0e0;
            border-radius: 4px;
          }
          
          .why-work-section .flip-back::-webkit-scrollbar-thumb {
            background: #ffd700;
            border-radius: 4px;
          }
        `}
      </style>
      
      <section className="why-work-section">
        <div className="container">
          <div className="heading-wrapper">
            <h4 className="subtitle">WHY CHOOSE US</h4>
            <h1 className="title">WORK WITH US</h1>
          </div>

          <div className="cards">
            {cardsData.map((card, index) => {
              const IconComponent = card.icon;
              const isActive = activeCards[index];
              
              return (
                <div 
                  key={card.id}
                  className={`flip-card fade-up delay-${index + 1} ${isActive ? 'active' : ''}`}
                  onClick={() => handleCardClick(index)}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCardClick(index);
                    }
                  }}
                  aria-label={`${card.title} - click to flip for more information`}
                >
                  <div className="flip-card-inner">
                    <div className="flip-front">
                      <IconComponent className="icon" />
                      <h3>{card.title}</h3>
                      <div className="card-number">0{card.id}</div>
                    </div>
                    <div className="flip-back">
                      <p>{card.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyWorkWithUs;